/** sessionStorage keys used for auth redirect and client session context. */

export const SESSION_STORAGE_KEYS = {
  REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
  EXPLICIT_LOGOUT: 'explicitLogout',
  LAST_ENTITY_CONTEXT: 'lastEntityContext',
  HEADER_DISPLAY_NAME: 'ntcog-header-display-name',
  HEADER_DISPLAY_NAME_OWNER: 'ntcog-header-display-name-owner',
  ENTITY_NAME_PREFIX: 'entityName_',
} as const;

export function entityNameCacheKey(scope: string, scopeId: number | string): string {
  return `${SESSION_STORAGE_KEYS.ENTITY_NAME_PREFIX}${scope}_${scopeId}`;
}
